
export enum TickOperCode {
  TICKET_TICK_OPER_CODE = 30,
  ZAPPING_TICK_OPER_CODE = 31
}
